export enum CheckoutTokenRequestType {
  GooglePay = 'googlepay',
  ApplePay = 'applepay',
}
